import {
    GET_CHATGPT,
    GET_CHATGPT_SUCCESS,
    CLEAR_JOB_ID_CHATGPT,
    SET_GPT_STATE,
    CHECK_JOB,
    CHECK_JOB_SUCCESS,
    CHECK_CENSOR_TEXT,
    CHECK_CENSOR_TEXT_SUCCESS,
    FETCH_SYNONYMS_REQUEST,
    FETCH_SYNONYMS_SUCCESS,
    FETCH_SYNONYMS_FAILURE,
    CHECK_JOB_MATCHING,
    CHECK_JOB_MATCHING_SUCCESS,
    CHECK_JOB_MATCHING_FAILURE,
} from '../action-types'

export const getChatgpt = (token, chat_type, params) => {
    return {
        type: GET_CHATGPT,
        token: token,
        chat_type: chat_type,
        params: params
    }
}

export const getChatgptSuccess = (data, chat_type) => {
    return {
        type: GET_CHATGPT_SUCCESS,
        data: data,
        chat_type: chat_type,
    }
}

export const checkJob = (token, id) => {
    return {
        type: CHECK_JOB,
        token: token,
        id: id
    }
}

export const checkJobSuccess = (data) => {
    return {
        type: CHECK_JOB_SUCCESS,
        data: data,
    }
}

export const checkCensorText = (token, text) => {
    return {
        type: CHECK_CENSOR_TEXT,
        token: token,
        text: text
    }
}

export const checkCensorTextSuccess = (data) => {
    return {
        type: CHECK_CENSOR_TEXT_SUCCESS,
        data: data,
    }
}

export const clearJobId = () => {
    return {
        type: CLEAR_JOB_ID_CHATGPT
    }
}

export const setGptState = (field, value) => {
    return {
        type: SET_GPT_STATE,
        payload: {
            key : field,
            value: value
        }
    }
}

export const fetchSynonymsRequest = (message, token) => ({
    type: FETCH_SYNONYMS_REQUEST,
    payload: { message: message.join(' '), token }
  });
  
  export const fetchSynonymsSuccess = (synonyms) => ({
    type: FETCH_SYNONYMS_SUCCESS,
    payload: synonyms,
  });
  
  export const fetchSynonymsFailure = (error) => ({
    type: FETCH_SYNONYMS_FAILURE,
    payload: error,
  });

export const checkJobMatching = (token, formData) => {
    return {
        type: CHECK_JOB_MATCHING,
        token: token,
        formData: formData
    }
}

export const checkJobMatchingSuccess = (data) => {
    return {
        type: CHECK_JOB_MATCHING_SUCCESS,
        data: data,
    }
}